jQuery(function ($) {


    if ($("#subscribeModal").length){  

    let showModal = true;
    if(sessionStorage.getItem("showZoneModal")) showModal = sessionStorage.getItem("showZoneModal");

    $(window).scroll(function (event) {
        let scroll = $(window).scrollTop();
        let position = document.documentElement.scrollHeight / 4;

        if (scroll > position) {

            if (showModal === true) {
                $('#subscribeModal').modal('show');
                showModal = false;
                sessionStorage.setItem("showZoneModal", false);
            };
        };
    });

    }

});
